/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useCallback, useMemo } from 'react'
import Header from "../header/Header"
import style from "./index.module.scss"

import bgGreen from "assets/img/bg/pic_1-1.png"
import bgBule from "assets/img/bg/pic_1-2.png"
import { useMappedState, useDispatch } from 'redux-react-hook'
import { createAction, SET_MENU, SET_SHOW_AREA } from 'store/ActionTypes'
import Footer from 'layouts/footer'
// import bg3 from "assets/img/bg/pic_3.png"

interface Props extends React.Props<any> {
  inContainer?: boolean,
}

const BaseLayout: React.FC<Props> = ({ children, inContainer = true }) => {
  const bg = pathTobackground(window.location.pathname)
  const [showMenu, showArea] = useMappedState(state => 
    [ state.user.showMenu, state.user.showArea ]
  )
  const dispatch = useDispatch()

  const closeMenu = useCallback((e) => {
    if (showMenu) {
      dispatch(createAction(SET_MENU, false))
    }
    if (showArea) {
      dispatch(createAction(SET_SHOW_AREA, false))
    }
  }, [dispatch, showMenu, showArea])

  return useMemo(() => (
    <div
      onClick={closeMenu}
      style={{ backgroundImage: `url(${bg})` }}
      className={style["g-base-layout"]}>
      <Header />
      {
        inContainer
          ? (
            <div className={'container ' + style.main}>
              { children }
            </div>
          )
          : children
      }
      <Footer />
    </div>
  ), [bg, children, closeMenu, inContainer])
}

function pathTobackground (path: string): string {
  if (/\/sign\/signup/.test(path)) {
    return bgBule
  } else if (/\/sign/.test(path)) {
    return bgGreen
  }
  return bgGreen
}

export default BaseLayout
